import React, { useEffect, useRef, useState } from 'react';

import Button from '../../../../library/button/button';
import FilterChips, {
  FilterChipValue
} from '../../../../library/filter-chips/filter-chips';
import Modal from '../../../../components/modal/modal';
import ProductListFilter from '../../../../components/product-list-filter/product-list-filter';

import { isChipFilter } from '../../../../shared/utils/filters/filters';

import styles from './product-list-filter-modal.scss';

interface ProductListFilterModalProps {
  categoryCode: string;
  defaultMaxPrice: number;
  defaultMinPrice: number;
  filters: FilterChipValue[];
  highestPriceInResults: number;
  isAccessorySearch: boolean;
  isOpen: boolean;
  isPrebuiltPackageSearch: boolean;
  isTextSearch: boolean;
  lowestPriceInResults: number;
  onClearSelectedFilters: () => void;
  onClose: () => void;
  onSliderValueChange: () => void;
  onUpdateSelectedFilters: (filterChip: FilterChipValue) => void;
  selectedFilters: FilterChipValue[];
}

function ProductListFilterModal(props: ProductListFilterModalProps) {
  const {
    categoryCode,
    defaultMaxPrice,
    defaultMinPrice,
    filters,
    highestPriceInResults,
    isAccessorySearch,
    isOpen,
    isPrebuiltPackageSearch,
    isTextSearch,
    lowestPriceInResults,
    onClearSelectedFilters,
    onClose,
    onSliderValueChange,
    onUpdateSelectedFilters,
    selectedFilters
  } = props;
  const filterContainerRef = useRef<HTMLDivElement | null>(null);
  const [scrollPositionValue, setScrollPositionValue] = useState(0);

  useEffect(() => {
    const container = filterContainerRef.current;
    if (container && scrollPositionValue) {
      setTimeout(() => {
        container?.scrollTo({
          behavior: 'smooth',
          top: scrollPositionValue
        });
      }, 1000);
    }
  }, [scrollPositionValue]);

  const handleFilterClick = filter => {
    if (filterContainerRef.current) {
      setScrollPositionValue(filterContainerRef.current.scrollTop);
    }
    onUpdateSelectedFilters(filter);
  };

  return (
    <Modal
      className={styles['container']}
      heading="Filters"
      isOpen={isOpen}
      onClose={onClose}
    >
      <div
        className={styles['filters']}
        data-testid="product-list-mobile-filters"
        ref={filterContainerRef}
      >
        <FilterChips
          filters={selectedFilters?.filter(isChipFilter)}
          onChipClick={onUpdateSelectedFilters}
          onClearAllClick={onClearSelectedFilters}
          showClearAll
        />

        <ProductListFilter
          accessoryCategory={categoryCode}
          defaultMaxPrice={defaultMaxPrice}
          defaultMinPrice={defaultMinPrice}
          filters={filters}
          highestPriceInResults={highestPriceInResults}
          isAccessorySearch={isAccessorySearch}
          isPrebuiltPackageSearch={isPrebuiltPackageSearch}
          isTextSearch={isTextSearch}
          lowestPriceInResults={lowestPriceInResults}
          onSelectFilter={handleFilterClick}
          onSliderValueChange={onSliderValueChange}
          selectedFilters={selectedFilters}
          toggleType="CHEVRON"
        />
      </div>
      <div className={styles['controls']}>
        <Button isSecondary onClick={onClearSelectedFilters}>
          Clear All
        </Button>
        <Button isPrimary onClick={onClose}>
          See Results
        </Button>
      </div>
    </Modal>
  );
}

export default ProductListFilterModal;
